export default "__VITE_ASSET__C9U2AMwW__"